module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "payWatch"
    }
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgScr
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "musk"
  }, [(_vm.type == 1) ? _c('div', {
    staticClass: "passwordBox"
  }, [_c('van-password-input', {
    attrs: {
      "value": _vm.value,
      "info": '说明：' + _vm.couponText
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.password
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('van-number-keyboard', {
    attrs: {
      "show": _vm.showKeyboard
    },
    on: {
      "input": _vm.onInput,
      "delete": _vm.onDelete
    }
  })], 1) : (_vm.type == 2) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("门票观看")]), _vm._v(" "), _c('div', {
    staticClass: "ticket"
  }, [_c('h4', [_vm._v("门票价格")]), _vm._v(" "), _c('h5', [_vm._v("￥ \n\t\t\t\t\t"), (_vm.payIndex >= 0) ? _c('span', {
    staticClass: "money"
  }, [((_vm.price >= _vm.coupons[_vm.payIndex].money) / 100) ? [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s((_vm.price - _vm.coupons[_vm.payIndex].money) / 100) + "\n\t\t\t\t\t\t")] : [_vm._v("\n\t\t\t\t\t\t\t0\n\t\t\t\t\t\t")]], 2) : _c('span', [_vm._v(_vm._s(_vm.price / 100))])])]), _vm._v(" "), (_vm.coupons.length) ? _c('ul', {
    staticClass: "coupons"
  }, [_vm._l((_vm.coupons), function(item, index) {
    return _c('li', {
      class: {
        cur: _vm.payIndex == index
      },
      on: {
        "click": function($event) {
          return _vm.select(index, item.id)
        }
      }
    }, [_c('i'), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.money / 100) + "元门票券")])])
  }), _vm._v(" "), _c('li', {
    class: {
      cur: _vm.payIndex == -1
    },
    on: {
      "click": function($event) {
        return _vm.select(-1, 0)
      }
    }
  }, [_c('i'), _vm._v(" "), _c('span', [_vm._v("不使用")])])], 2) : _vm._e(), _vm._v(" "), (_vm.couponText) ? _c('p', {
    staticClass: "explain"
  }, [_vm._v("说明：" + _vm._s(_vm.couponText))]) : _c('p', {
    staticClass: "explain"
  }, [_vm._v("说明：请购买门票进行观看")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.bugTicket
    }
  }, [_vm._v("购买")])]) : _c('div', {
    staticClass: "box allot shareCard"
  }, [_c('img', {
    attrs: {
      "src": _vm.allot.pic
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "allot_title"
  }, [_vm._v(_vm._s(_vm.allot.title)), _c('span', [_vm._v("精选课程")])]), _vm._v(" "), _c('div', {
    staticClass: "allot_price"
  }, [_c('span', {
    staticClass: "yuan"
  }, [_vm._v("￥")]), _vm._v(_vm._s(_vm.allot.price / 100))]), _vm._v(" "), _c('div', {
    staticClass: "allot_ul"
  }, [_vm._v("\n\t\t\t\t邀请收益：¥ " + _vm._s(_vm.allot.allot_money / 100) + " / 人 "), _c('span'), _vm._v("收益比例：" + _vm._s(_vm.allot.rate * 100) + "％\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "allot_yao",
    on: {
      "click": _vm.onshowArrow
    }
  }, [_vm._v("邀请好友")]), _vm._v(" "), _c('div', {
    staticClass: "allot_pay",
    on: {
      "click": _vm.allotPay
    }
  }, [_vm._v("立即购买")]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showArrow),
      expression: "showArrow"
    }],
    staticClass: "musk2",
    on: {
      "click": _vm.oncloseArrow
    }
  }, [_c('div', {
    staticClass: "arrow"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'payWatch/arrow.png'
    }
  }), _vm._v(" "), _c('p', [_vm._v("点击这里分享邀请哦～")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "allot_info"
  }, [_c('h4', [_vm._v("邀请说明")]), _vm._v(" "), _c('p', [_vm._v("每当好友购买成功，即可立即获得本次邀请收益，收益将自动存入您的"), _c('span', [_vm._v("微信钱包")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8888c28"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/payWatch.vue
// module id = 280
// module chunks = 0